export const formatManualVersion = (manualVersion?: string) => {
  if (!manualVersion) return '-'
  return manualVersion.replace(/_/g, '.')
}
